import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleRemoveList(
  list: Identifiable<List>,
  listToRemove: Boundaries["removeList"]["success"],
): Identifiable<List> {
  return {
    ...list,
    subLists: list.subLists
      .filter(({ uuid }) => listToRemove.uuid !== uuid)
      .map((subList) => handleRemoveList(subList, listToRemove)),
  };
}

export { handleRemoveList };
